export default {
  IMAGE_TYPES: {
    IMAGE: 'IMAGE',
    CAROUSEL: 'CAROUSEL_ALBUM',
  },

  CONTEXTS: {
    RECENT: 1,
  },

  TOKEN_TTL_MINUTES: 60,
};
